import { Fragment } from 'react'

import { ChevronRight } from 'lucide-react'

import { Button } from '~/components/component-library'
import { StepIndex } from '~/hooks/useSmartAccountSetupStep'
import { cn } from '~/utils/tailwind-utils'

export const Breadcrumb = ({
  step,
  setStep,
  availableStep,
  isSavingFinalStep,
  index,
  label,
}: {
  step: StepIndex
  setStep: (step: StepIndex) => void
  availableStep: number
  isSavingFinalStep: boolean
  index: number
  label: string
}) => {
  return (
    <Fragment key={index}>
      {index > 0 && <ChevronRight className="h-4 text-secondary" />}
      <Button
        variant="tertiary"
        className={cn([
          'select-none border border-transparent capitalize focus:ring-0 focus-visible:ring-2 focus-visible:ring-blue-500',
          'px-2 py-1',
          {
            '-ml-2': index === 0,
            'pointer-events-none !text-blue-500': step === index,
            'pointer-events-none text-secondary':
              (availableStep < index && step !== index) || isSavingFinalStep,
          },
        ])}
        isDisabled={
          (availableStep < index && step !== index) || isSavingFinalStep
        }
        onClick={() => {
          setStep(index as StepIndex)
        }}
      >
        {label}
      </Button>
    </Fragment>
  )
}
